import {connect} from 'react-redux';
import IngestConfigContainer from '../IngestConfig/IngestConfigContainer';
import {createNewIngestItemAction} from './Redux/CreatingNewIngestActions';

export const mapDispatch = {
    saveIngestConfigItem: createNewIngestItemAction,
};

export default connect(null, mapDispatch)(IngestConfigContainer as any);
